module.exports = __webpack_public_path__ + "media/images/finished-195684ae923ef659443d432faa209add.png";